import React from 'react';
import { Card, CardContent } from '../ui/card';

export const CustomRequestsTable = ({ requests, busy }) => (
  <Card className="border-stone-taupe/20">
    <CardContent className="p-0 overflow-x-auto">
      <table className="w-full text-sm">
        <thead className="bg-soft-linen text-left">
          <tr>
            <th className="p-3">Name</th>
            <th className="p-3">Email</th>
            <th className="p-3">Event</th>
            <th className="p-3">Date</th>
            <th className="p-3">Budget</th>
            <th className="p-3">Submitted</th>
          </tr>
        </thead>
        <tbody>
          {requests.map((r) => (
            <tr key={r.requestId} className="border-t border-stone-taupe/10">
              <td className="p-3">{r.fullName}</td>
              <td className="p-3">{r.email}</td>
              <td className="p-3 capitalize">{(r.eventType || '').replace('-', ' ')}</td>
              <td className="p-3">{r.eventDate}</td>
              <td className="p-3">{r.budget}</td>
              <td className="p-3 text-xs text-stone-taupe">{r.createdAt ? new Date(r.createdAt).toLocaleString() : '—'}</td>
            </tr>
          ))}
          {requests.length === 0 && !busy && (
            <tr><td className="p-6 text-center text-stone-taupe" colSpan={6}>No custom requests yet</td></tr>
          )}
        </tbody>
      </table>
    </CardContent>
  </Card>
);

export const DesignDetailsTable = ({ details, busy }) => (
  <Card className="border-stone-taupe/20">
    <CardContent className="p-0 overflow-x-auto">
      <table className="w-full text-sm">
        <thead className="bg-soft-linen text-left">
          <tr>
            <th className="p-3">Order #</th>
            <th className="p-3">Email</th>
            <th className="p-3">Theme</th>
            <th className="p-3">Style</th>
            <th className="p-3">Order Type</th>
            <th className="p-3">Submitted</th>
          </tr>
        </thead>
        <tbody>
          {details.map((d) => (
            <tr key={d.detailsId} className="border-t border-stone-taupe/10">
              <td className="p-3 font-mono">{d.orderNumber}</td>
              <td className="p-3">{d.email}</td>
              <td className="p-3">{d.theme}</td>
              <td className="p-3 capitalize">{(d.style || '').replace('-', ' ')}</td>
              <td className="p-3 capitalize">{d.orderType}</td>
              <td className="p-3 text-xs text-stone-taupe">{d.submittedAt ? new Date(d.submittedAt).toLocaleString() : '—'}</td>
            </tr>
          ))}
          {details.length === 0 && !busy && (
            <tr><td className="p-6 text-center text-stone-taupe" colSpan={6}>No design details yet</td></tr>
          )}
        </tbody>
      </table>
    </CardContent>
  </Card>
);
